<template>
  <section>
    <left-menu />

    <div id="contentBack" class="back-link">
      <router-link v-bind:to="'/lista-de-ferias-afastamento'">
        <i aria-hidden="true" class="fa fa-arrow-left"></i>
        <span> {{$t("Voltar")}}</span>
      </router-link>
    </div>

    <div id="mainContent" class="list-holiday">

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 box-content-title-page">
          <h1>{{$t("Solicitar Férias/Afastamento")}}</h1>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-6 offset-top-20">
          <!-- Box Filter -->
          <div class="col-xs-12 col-sm-12 col-md-12 default-box filter-box">
            <div class="row">
              <div class="col-md-12">
                <div class="col-md-10 col-lg-8 offset-top-30">
                  <div class="select-type">
                    <a v-on:click="dataModel.vacationtype = 1" v-bind:class="{'selected-type': dataModel.vacationtype === 1}">{{$t("Férias")}}</a>
                    <a v-on:click="dataModel.vacationtype = 2" v-bind:class="{'selected-type': dataModel.vacationtype === 2}">{{$t("Afastamento")}}</a>
                  </div>
                </div>
                <div v-if="dataModel.vacationtype === 2" class="col-md-12 offset-top-30">
                  <label>{{$t("Tipo de afastamento")}}<span class="required-field">*</span></label>
                  <select v-model="dataModel.userVacationType">
                    <option value="">{{$t("Selecione")}}</option>
                    <option v-for="m in listHoliday" v-bind:value="m.id">
                      {{m.name}}
                    </option>
                  </select>
                  <span v-if="invalidUserVacationType && !dataModel.userVacationType" class="required-field">{{$t("Campo obrigatório.")}}</span>
                </div>
              </div>
            </div>


            <div class="col-xs-12 col-sm-6 col-md-6 offset-top-20">
              <div class="input-with-date">
                <label>{{$t("Início")}}<span class="required-field">*</span></label>
                <datepicker
                  placeholder="Selecione"
                  v-model="initDate"
                  :format="datePickerFormat"
                  :language="ptBR"/>
                <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z" class="a"></path></svg>
                <span v-if="invalidInitDate && !initDate" class="required-field">{{$t("Campo obrigatório.")}}</span>
              </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-6 offset-top-20">
              <div class="input-with-date">
                <label>{{$t("Término")}}<span class="required-field">*</span></label>
                <datepicker
                  placeholder="Selecione"
                  v-model="endDate"
                  :format="datePickerFormat"
                  :language="ptBR"/>
                <svg width="24" height="24" viewBox="0 0 24 24"><path d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z" class="a"></path></svg>
                <span v-if="invalidEndDate && !endDate" class="required-field">{{$t("Campo obrigatório.")}}</span>
              </div>
            </div>

            <div v-if="diffDays" class="col-md-12 offset-top-20">
              <label>{{$t("Quantidade de dias")}}</label>
              <p class="total-days">{{ diffDays }} {{ diffDays > 1 ? 'dias' : 'dia'}}</p>
            </div>

            <div class="col-md-12 offset-top-20">
              <div class="new-input-group">
                <label>{{$t("Adicionar anexo")}}</label>
                <input type="file" id="documentFile" ref="myFiles" class="custom-file-input" @change="previewFiles" style="display: none">
                <input @click="attachFile('#documentFile')" v-model="fileName" class="form-control" placeholder="JPG ou PDF" type="text" name="document">
                <img v-if="uploadStage === 'success'" src="../../../../assets/img/conf_send.png" class="status-file" height="22" width="22">
                <img v-if="uploadStage === 'fail'" src="../../../../assets/img/fail_send.png" class="status-file" height="22" width="22">
                <div v-if="uploadStage === 'loading'" class="loading-file">
                  <span><i class="glyphicon glyphicon-repeat spinning"></i></span>
                </div>
                <button class="input-group-btn" v-on:click="attachFile('#documentFile')" type="button">{{$t("Selecione")}}</button>
              </div>
            </div>
            <div v-if="needException" class="col-md-12 offset-top-20">
              <label>{{$t("Motivo do ponto por exceção")}}<span class="required-field">*</span></label>
              <select v-model="selectedException">
                <option value="">{{$t("Selecione")}}</option>
                <option v-for="m in listException" :value="m" :key="m.id">
                  {{m.name}}
                </option>
              </select>
              <span v-if="validateException" class="required-field">{{$t("Campo obrigatório.")}}</span>

            </div>

            <div class="col-md-12 offset-top-20">
              <label>{{$t("Observação")}} <span class="required-field">*</span></label>
              <textarea v-model="dataModel.requestNotes" placeholder="Digite aqui"></textarea>
              <span v-if="invalidRequestNotes && !dataModel.requestNotes" class="required-field">{{$t("Campo obrigatório.")}}</span>
            </div>

            <div class="col-md-12 offset-top-20">
              <button @click="checkDataSend()" type="submit" class="btn-default-success">
                <div v-if="loadingSend" class="loading-btn">
                  <div class="spinner-btn">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
                <span v-else>
                    <svg width="24" height="24" viewBox="0 0 24 24">
                      <path class="a" d="M2.01,21,23,12,2.01,3,2,10l15,2L2,14Z"/>
                    </svg>
                  <span>{{$t("Enviar Solicitação")}}</span></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
import leftMenu from "../../components/leftMenu.vue";
import vueFooter from "../../components/footer";
import fullLoading from "../../components/blueFullLoading";
import datepicker from "vuejs-datepicker";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import moment from "moment";
import MugenScroll from "vue-mugen-scroll";
import swal from "sweetalert";
import Autocomplete from "vue2-autocomplete-js";

import {
  ABSENCE_EMPLOYEE,
  CREATE_ABSENCE_EMPLOYEE,
  GET_EXCEPTION,
  GET_LIST_HOLIDAY,
  UPLOAD_IMG
} from "../../../../urlConfig";
import { REQUEST_SERVICE } from "../../../../requestConfig";
import { UTIL_SERVICE } from "../../../../utils";

export default {
  name: "request-holiday",
  components: {
    fullLoading,
    leftMenu,
    vueFooter,
    datepicker,
    Autocomplete,
    MugenScroll
  },
  data() {
    return {
      userInfo: null,
      initDate: null,
      endDate: null,
      datePickerFormat: "dd/MM/yyyy",
      needException: false,
      validateException: false,
      selectedException: "",
      ptBR: ptBR,
      diffDays: null,
      dataModel: {
        vacationtype: 1,
        userVacationType: "",
        initDate: "",
        endDate: "",
        requestNotes: "",
        imageUri: "",
        fromWhere: 6
      },
      uploadStage: "",
      files: [],
      fileName: "",
      loadingSend: false,
      failRequest: false,
      loadingList: false,
      listHoliday: [],
      listException: [],
      invalidInitDate: "",
      invalidEndDate: "",
      invalidUserVacationType: "",
      invalidRequestNotes: ""
    };
  },
  methods: {
    uploadDocument(file) {
      this.uploadStage = "loading";
      this.fileName = file.name;
      REQUEST_SERVICE.fileUpload(UPLOAD_IMG, file)
        .then(response => {
          UTIL_SERVICE.console("RESULT UPLOAD DOCUMENT: ", response);

          this.dataModel.imageUri = response.data;
          this.uploadStage = "success";
        })
        .catch(reason => {
          this.uploadStage = "fail";
        });
    },
    previewFiles() {
      this.files = this.$refs.myFiles.files;
      if (this.files.length) {
        if (this.files[0].size <= 2097152) {
          this.uploadDocument(this.files[0]);
        } else {
          swal(
            this.$t("Aviso"),
            this.$t("Não foi possivel realizar o envio da imagem.\n\n Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB."),
            "warning"
          );
        }
      }
    },
    attachFile(id) {
      $(id).click();
    },
    calcDays() {
      if (this.initDate && this.endDate) {
        const timeDiff = Math.abs(
          this.endDate.getTime() - this.initDate.getTime()
        );
        this.diffDays = 1 + Math.ceil(timeDiff / (1000 * 3600 * 24));
      }
    },
    checkDataSend() {
      this.invalidInitDate = false;
      this.invalidEndDate = false;
      this.invalidUserVacationType = false;
      this.invalidRequestNotes = false;
      if (!this.loadingSend) {
        if (
          this.initDate &&
          this.endDate &&
          ((this.dataModel.vacationtype === 2 &&
            this.dataModel.userVacationType) ||
            this.dataModel.vacationtype === 1) &&
          this.dataModel.requestNotes
        ) {
          this.dataModel.initDate = moment(this.initDate).format("YYYY-MM-DD");
          this.dataModel.endDate = moment(this.endDate).format("YYYY-MM-DD");

          if (this.dataModel.vacationtype === 1) {
            this.dataModel.userVacationType = 1;
          }

          if (this.needException) {
            if (this.selectedException) {
              this.dataModel.sporadicCategoryId = this.selectedException.id;
            } else {
              if (this.listException.length) {
                return (this.validateException = true);
              }
            }
          }

          this.loadingSend = true;

          UTIL_SERVICE.console("Data send:", this.dataModel);
          REQUEST_SERVICE.post(CREATE_ABSENCE_EMPLOYEE, this.dataModel)
            .then(response => {
              UTIL_SERVICE.console(
                "RESULT CREATE_ABSENCE_EMPLOYEE:",
                response.data
              );

              swal(this.$t("Sucesso"), this.$t("Solicitação realizada com sucesso."), "success");

              this.$router.push({ path: "/lista-de-ferias-afastamento" });

              this.loadingSend = false;
            })
            .catch(reason => {
              this.loadingSend = false;
              // Show errors.
              reason.response.data.erros.map((value, index) => {
                swal(this.$t("Aviso"), value.value, "error");
              });
            });
        } else {
          if (!this.initDate) {
            this.invalidInitDate = true;
          }
          if (!this.endDate) {
            this.invalidEndDate = true;
          }
          if (!this.dataModel.userVacationType) {
            this.invalidUserVacationType = true;
          }
          if (!this.dataModel.requestNotes) {
            this.invalidRequestNotes = true;
          }
        }
      }
    },
    getListHoliday() {
      this.loadingList = false;
      REQUEST_SERVICE.get(GET_LIST_HOLIDAY)
        .then(response => {
          UTIL_SERVICE.console("RESULT GET_LIST_HOLIDAY:", response.data);
          response.data.map(v => {
            if (
              v.name.toLowerCase().includes("férias") ||
              v.name.toLowerCase().includes("ferias")
            ) {
            } else {
              this.listHoliday.push(v);
            }
          });

          this.loadingList = false;
        })
        .catch(reason => {
          this.loadingList = false;
        });
    },
    getListException() {
      REQUEST_SERVICE.get(GET_EXCEPTION).then(response => {
        UTIL_SERVICE.console("RESULT GET_EXCEPTION:", response.data);

        this.listException = response.data;
      });
    }
  },
  beforeMount() {
    this.getListHoliday();
    this.getListException();
    this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    this.calcDays();
    this.needException = this.userInfo.company.sporadic;
  },
  watch: {
    initDate: function(val) {
      if (this.endDate && this.initDate) {
        this.calcDays();
      }
    },
    endDate: function(val) {
      if (this.endDate && this.initDate) {
        this.calcDays();
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.list-holiday {
  .filter-box {
    margin-bottom: 80px;
    padding-bottom: 40px;

    .select-type {
      margin-top: 25px;

      a {
        width: calc(100% / 2 - 10px);
        height: 36px;
        line-height: 34px;
        margin: 0;
        display: inline-block;
        background: #eef2f7;
        border-radius: 18px;
        font-family: "Montserrat", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        color: #3a424e;

        &:hover {
          text-decoration: none;
          background: var(--linkColor);
          color: #ffffff;
        }
      }

      .selected-type {
        background: var(--linkColor) !important;
        color: #ffffff !important;
      }
    }
  }

  .box-empty {
    margin-top: 30px;

    p {
      font-family: "Montserrat", sans-serif;
      color: var(--defaultText);
    }
  }

  .pg-title {
    position: relative;
    margin-bottom: 20px;

    .btn-title {
      position: absolute;
      top: 18px;
      right: 16px;
      min-width: 225px;
      height: 39px;
      line-height: 39px;
      text-align: center;
      text-decoration: none;
      background: var(--linkColor);
      border-radius: 4px;
      font-family: "Montserrat", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      cursor: pointer;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .filter-title {
    margin-top: 30px;
    margin-bottom: 0;
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    color: var(--textSide);
  }

  .btn-search {
    background: var(--linkColor);
    width: 100%;
    max-width: 109px;
    height: 36px;
    cursor: pointer;
    margin-top: 15px;
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border-radius: 4px;
    border: none;

    &:hover {
    }
  }

  .total-days {
    margin: 0;
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 17px;
    color: var(--titleBox);
    opacity: 0.75;
  }
}

textarea {
  max-width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/holiday/requestHoliday.vue